import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
interface FormNavigationProps {
  currentStep: number;
  onNext: () => void;
  onPrevious: () => void;
  onShowTerms: () => void;
  isNextDisabled?: boolean;
  showValidationError?: boolean;
}
export const FormNavigation = ({
  currentStep,
  onNext,
  onPrevious,
  onShowTerms,
  isNextDisabled,
  showValidationError = false
}: FormNavigationProps) => {
  const getValidationMessage = () => {
    if (!isNextDisabled) return null;
    switch (currentStep) {
      case 1:
        return "Please complete all required address fields to continue";
      case 2:
        return "Please complete all required contact information to continue";
      case 3:
        return "Please complete all required parcel details and collection time to continue";
      default:
        return null;
    }
  };
  const validationMessage = getValidationMessage();
  return <div className="space-y-3 w-full">
      <div className="flex flex-col sm:flex-row justify-between gap-2 sm:gap-0 my-4">
        {currentStep > 1 && <Button variant="outline" onClick={onPrevious} className={`mx-0 sm:mx-[5px] w-full ${currentStep > 1 ? 'sm:w-1/2' : 'sm:w-auto'}`}>
            Previous
          </Button>}
        {currentStep < 4 ? 
          <Button 
            onClick={onNext} 
            disabled={isNextDisabled} 
            className={`ml-0 sm:ml-auto mx-0 sm:mx-[5px] w-full ${currentStep > 1 ? 'sm:w-1/2' : 'sm:w-full'}`}
          >
            Next
          </Button> 
          : 
          <Button 
            className={`ml-0 sm:ml-auto w-full ${currentStep > 1 ? 'sm:w-1/2' : 'sm:w-full'}`} 
            onClick={onShowTerms}
          >
            Confirm
          </Button>
        }
      </div>
      
      {showValidationError && validationMessage && <div className="flex items-start gap-2 text-sm text-[hsl(var(--validation-error))] bg-[hsl(var(--validation-error))]/10 border border-[hsl(var(--validation-error-border))]/30 rounded-lg p-3 mx-2 sm:mx-0">
          <AlertTriangle className="h-4 w-4 flex-shrink-0 mt-0.5" />
          <span className="text-left">{validationMessage}</span>
        </div>}
    </div>;
};